import React from "react";
import { Container, ContentImage, Image, Content } from "./style";
import Divisor from "../Divisor";
import myImage from "../../assets/my-image.jpg";

export default function Profile({ children }) {
  return (
    <Container>
      <ContentImage>
        <Image src={myImage} alt="my" />
      </ContentImage>
      <Divisor />
      <Content>{children}</Content>
    </Container>
  );
}
